import React, { useRef } from 'react';
import { Link } from 'react-router-dom'

import SearchBox from '../../components/psc/lib/SearchBox'
import StatusOptionsMulti from '../../components/psc/lib/StatusOptionsMulti'
import GncDataTable from '../../components/psc/lib/GncDataTable'
import useTableSlots from '../../hooks/useTableSlots'
import useBrowserTabTitle from '../../hooks/useBrowserTabTitle'

const ReferenceStructures = () => {
    useBrowserTabTitle('Reference Structures')

    const table = useRef(null)
    const urlGetData = '/v0/reference_structures'
    const localStorageOrderKey = 'tblReferenceStructuresOrder'
    const defaultOrder = [[ 0, 'asc' ]]

    const {
        linkSlot,
    } = useTableSlots()

    const columns = [
        { data: 'name' },
        { data: 'cadm_object.name' },
    ]

    const tableHead = (
        <tr>
            <th>Name</th>
            <th>Configured Item</th>
        </tr>
    )

    const tableSlots = {
        0: (data, type, row) => linkSlot(data, type, row, `/cadm/reference_structures/${row.id}`),
        1: (data, type, row) => linkSlot(data, type, row, `/cadm/reference_structures/${row.id}`),
    }

    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h2>Reference Structures</h2>

                            <div className="pre-table-buttons">
                                <Link to="/cadm/reference_structures/new" className="btn btn-mr btn-primary" type="button">New Reference Structure</Link>
                                <Link to="/cadm/project_configuration_schemes">Configuration Schemes</Link>
                            </div>
                            
                            <div key="newText1" style={{color: 'rgba(103, 106, 108, 0.65)'}}>
                                <strong>Reference structures</strong> define the composition of the unique reference applied to each type of <strong>configured item</strong>.<br/>
                              A reference structure can be applied to one or many <strong>opportunities, projects, or products</strong> through <strong>configuration schemes</strong>.
                            </div>

                        </div>
                        <div className="ibox-content">
                            <div className="row">
                                <SearchBox tableRef={table} />
                                <StatusOptionsMulti
                                    tableRef={table}
                                    statusColumnIndex="1"
                                    fetchUrl="/v0/cadm_objects"
                                    objectFilterCb={(item) => { return item.do_use_reference_structure } }
                                    localStorageKey="reference_structures-cadm-objects"
                                    placeholder="Select Configured Item..."
                                />
                            </div>

                            <GncDataTable
                                tableRef={table}
                                dataUrl={urlGetData}
                                defaultOrder={defaultOrder}
                                localStorageOrderKey={localStorageOrderKey}
                                columns={columns}
                                tableSlots={tableSlots}
                                tableHead={tableHead}
                                tableFoot={tableHead}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default ReferenceStructures
